var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_244_33532",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_244_33532)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 2.13333H11.4286V4.26667H24V2.13333ZM11.4286 6.4V8.53333H24V6.4H11.4286ZM11.4286 10.6667H0V12.8H24L24 10.6667H11.4286ZM0 16V14.9333H24V16H0Z",
    fill: "#0E4DC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71422 7.45705L4.95129 8.51997L4.75804 7.25335L3.57654 7.90206L3.99124 6.68262L2.62518 6.78862L3.5657 5.85789L2.28564 5.4002L3.5657 4.9425L2.62518 4.01177L3.99124 4.11777L3.57654 2.89833L4.75804 3.54704L4.95129 2.28043L5.71422 3.34335L6.47715 2.28043L6.67039 3.54704L7.8519 2.89833L7.43719 4.11777L8.80325 4.01177L7.86273 4.9425L9.14279 5.4002L7.86273 5.85789L8.80325 6.78862L7.43719 6.68262L7.8519 7.90206L6.67039 7.25335L6.47715 8.51997L5.71422 7.45705ZM5.71421 7.43656C6.9192 7.43656 7.89603 6.52485 7.89603 5.40019C7.89603 4.27554 6.9192 3.36383 5.71421 3.36383C4.50923 3.36383 3.5324 4.27554 3.5324 5.40019C3.5324 6.52485 4.50923 7.43656 5.71421 7.43656ZM7.4285 5.33334C7.4285 6.21699 6.66099 6.93334 5.71422 6.93334C4.76744 6.93334 3.99993 6.21699 3.99993 5.33334C3.99993 4.44968 4.76744 3.73334 5.71422 3.73334C6.66099 3.73334 7.4285 4.44968 7.4285 5.33334Z",
    fill: "#FED443"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/UY.4b89499bad50ddee08571689ef193d84.svg";
export { ForwardRef as ReactComponent };